export const fetchSendProjection = {
  _id: 1,
  name: 1,
  "programs.name": 1,
  "programs.order": 1,
  "programs.sessions.week": 1,
  "owner._id": 1,
  "createdBy._id": 1,
  storeType: 1,
};

export const copiableProjection = {
  name: 1,
  type: 1,
  status: 1,
  isDeleted: 1,
  "programs.name": 1,
  "programs.order": 1,
  "programs.sessions.week": 1,
  // session.exercises is an array of ids, not subdocuments: projecting
  // "exercises._id" would drop every element and leave the array empty.
  "programs.sessions.exercises": 1,
  "owner._id": 1,
  "createdBy._id": 1,
  storeType: 1,
};

export const dayProgramProjection = {
  _id: 1,
  type: 1,
  name: 1,
  programs: 1,
};
